import { useLocation } from "react-router-dom";
import { Heart } from "lucide-react";
import { ETSY_SHOP } from "../data/site";

const links = [
  { label: "Collections", href: "/collections", id: "nav-collections" },
  { label: "Bundles", href: "#bundles", id: "nav-bundles" },
  { label: "Dolly Tribute", href: "/tribute", id: "nav-tribute" },
  { label: "Story", href: "/story", id: "nav-story" },
  { label: "Travel", href: "/travel", id: "nav-travel" },
  { label: "Shop All", href: "/shop", id: "nav-shop-all" },
];

export const Header = () => {
  const { pathname } = useLocation();
  const prefix = pathname === "/" ? "" : "/";

  return (
    <header className="fixed top-0 left-0 z-50 w-full border-b border-navy/10 bg-cream/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a href={`${prefix}#top`} data-testid="header-logo" className="font-caveat text-3xl font-bold leading-none text-navy">
          Dream Freely
          <Heart className="mb-1 ml-1 inline-block h-4 w-4 fill-mustard text-mustard" />
        </a>
        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href.startsWith("/") ? l.href : `${prefix}${l.href}`}
              data-testid={l.id}
              className="text-xs font-medium uppercase tracking-[0.2em] text-navy/60 transition-colors duration-300 hover:text-navy"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="/travel"
            data-testid="header-book-travel-btn"
            className="hidden rounded-full border border-navy px-5 py-2.5 text-xs font-medium uppercase tracking-[0.2em] text-navy transition-transform duration-300 hover:scale-95 sm:inline-block md:px-6"
          >
            Book Travel
          </a>
          <a
            href={ETSY_SHOP}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-shop-etsy-btn"
            className="rounded-full bg-navy px-5 py-2.5 text-xs font-medium uppercase tracking-[0.2em] text-cream transition-transform duration-300 hover:scale-95 md:px-6"
          >
            Shop on Etsy
          </a>
        </div>
      </div>
    </header>
  );
};
